import { Region } from '../types';

export const regions: Region[] = [
  { id: 'europe', name: 'Europe', hasStates: true },
  { id: 'americas', name: 'Americas', hasStates: true },
  { id: 'africa', name: 'Africa', hasStates: true },
  { id: 'asia', name: 'Asia', hasStates: true },
  { id: 'oceania', name: 'Oceania', hasStates: true }
];